import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { EntityType } from './entityLinkUtils';
import { EntityLinkMenu } from './EntityLinkMenu';
import styles from '../ChatWidget.module.scss';

interface EntityLinkProps {
  type: EntityType;
  id: number;
  name?: string;
  children: React.ReactNode;
}

export function EntityLink(props: EntityLinkProps) {
  const { type, id, name, children } = props;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [anchorRect, setAnchorRect] = useState<DOMRect | null>(null);
  const linkRef = useRef<HTMLSpanElement>(null);

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    if (linkRef.current) {
      setAnchorRect(linkRef.current.getBoundingClientRect());
      setIsMenuOpen(true);
    }
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
    setAnchorRect(null);
  };

  return (
    <>
      <span
        ref={linkRef}
        className={styles.entityLink}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick(e as unknown as React.MouseEvent);
          }
        }}
      >
        {children}
      </span>
      {isMenuOpen && anchorRect && createPortal(
        <EntityLinkMenu
          type={type}
          id={id}
          name={name}
          anchorRect={anchorRect}
          onClose={handleCloseMenu}
        />,
        document.body
      )}
    </>
  );
}
